export class NeqErrorModel {
  type: string;
  code?: string;
  message: string;
  detail?: any;
  uuid: string;
  time: number;
}
